import { z } from "zod";

export type RpcParseResult<T> =
  | { success: true; data: T }
  | { success: false; error: z.ZodError };

export const safeParseRpc = <TSchema extends z.ZodType>(
  schema: TSchema,
  data: unknown,
): RpcParseResult<z.infer<TSchema>> => {
  const result = schema.safeParse(data);
  if (result.success) {
    return { success: true, data: result.data };
  }
  return { success: false, error: result.error };
};

export const parseRpcOrFallback = <TSchema extends z.ZodType>(
  schema: TSchema,
  data: unknown,
  fallback: z.infer<TSchema>,
  label?: string,
): z.infer<TSchema> => {
  const result = safeParseRpc(schema, data);
  if (result.success) return result.data;

  console.error(
    label ? `Invalid RPC response (${label}):` : "Invalid RPC response:",
    result.error,
  );
  return fallback;
};
